import React from 'react';

const TrustpilotRating = () => {
    // Create a reference to the <div> element which will represent the TrustBox
    const ref = React.useRef(null);
    React.useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    return (
        <div
            ref={ref} // We need a reference to this element to load the TrustBox in the effect.
            className="trustpilot-widget" 
            data-locale="en-US"
            data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="5e4b32c580da5a0001aed9a1"
            data-style-height="24px"
            data-style-width="100%"
            data-theme="light"
        >
            <a
                href="https://www.trustpilot.com/review/example.com"
                target="_blank"
                rel="noopener"
            >
                {' '}
                Trustpilot
            </a>
        </div>
    );
};

export default TrustpilotRating;
